export default {
  english: {
    title: 'Comments',
    writeNewComment: 'Write a comment ...',
    noComments: 'No comments have been written yet. Be the first!',
    beingModerated: 'Your comment is under moderation.',
    error: 'An error occurred, please retry later.',
    yes: 'Yes',
    no: 'No',
    areYouSure: 'Are you sure to delete the comment?',
    reply: 'Reply',
    replies: '{{ count }} replies',
    hideReplies: 'Hide replies',
    deletedComment: 'This comment has been deleted.',
    like: 'like',
    dislike: 'dislike',
    unlike: 'Unlike',
    undislike: 'Undislike',
    sendNewComment: 'Send new comment',
    deleteComment: 'Delete comment',
  },
  french: {
    title: 'Commentaires',
    writeNewComment: 'Écrire un commentaire ...',
    noComments: 'Aucun commentaire n\'a été posté. Soyez le premier !',
    beingModerated: 'Votre commentaire est en cours de modération.',
    error: 'Une erreur s\'est produite, veuillez réessayer ultérieurement.',
    yes: 'Oui',
    no: 'Non',
    areYouSure: 'Êtes vous sûr de vouloir supprimer le commentaire?',
    reply: 'Répondre',
    replies: '{{ count }} réponses',
    hideReplies: 'Masquer les réponses',
    deletedComment: 'Ce commentaire a été supprimé.',
    like: 'J\'aime',
    dislike: 'Je n\'aime pas',
    unlike: 'J\'aime',
    undislike: 'Je n\'aime pas',
    sendNewComment: 'Envoyer un nouveau commentaire',
    deleteComment: 'Supprimer le commentaire',
  },
  arabic: {
    title: 'تعليقات',
    writeNewComment: 'اكتب تعليقًا جديدًا ...',
    noComments: 'لا توجد تعليقات مكتوبة حتى الآن. كن الأول!',
    beingModerated: 'تعليقك تحت الاعتدال.',
    error: 'حدث خطأ ، يرجى إعادة المحاولة لاحقًا',
    yes: 'نعم',
    no: 'لا',
    areYouSure: 'هل أنت متأكد من حذف التعليق؟',
    reply: 'للرد',
    replies: 'رُدود {{ count }}',
    hideReplies: 'اخفاء الردود',
    deletedComment: 'تم حذفُ هذا التعليق.',
    like: 'مثل',
    dislike: 'لم يعجبنى',
    unlike: 'مثل',
    undislike: 'لم يعجبنى',
    sendNewComment: 'إرسال تعليق جديد',
    deleteComment: 'حذف تعليق',
  },
  hebrew: {
    title: 'תגובות',
    writeNewComment: 'הוסף תגובה',
    noComments: 'אין עדיין תגובות. היה הראשון להגיב',
    beingModerated: 'תגובתך בבדיקה',
    error: 'ארעה שגיאה אנא נסה מאוחר יותר',
    yes: 'כן',
    no: 'לא',
    areYouSure: 'האם אתה בטוח שברצונך למחוק את התגובה?',
    reply: 'הגב',
    replies: '{{ count }} תגובות',
    hideReplies: 'הסתר תגובות',
    deletedComment: 'תגובה זו נמחקה',
    like: 'אהבתי',
    dislike: 'לא אהבתי',
    unlike: 'ביטול לייק',
    undislike: 'ביטול דיסלייק',
    sendNewComment: 'שלחת תגובה חדשה',
    deleteComment: 'מחק תגובה',
  },
  persian: {
    title: 'نظرات',
    writeNewComment: 'کامنت بنویس...',
    noComments: 'هنوز نظری نوشته نشده است. اولین باشید!',
    beingModerated: 'نظر شما تحت نظارت است.',
    error: 'خطایی روی داد، لطفاً بعداً دوباره امتحان کنید.',
    yes: 'بله',
    no: 'خیر',
    areYouSure: 'آیا مطمئن هستید که نظر را حذف می کنید؟',
    reply: 'پاسخ دهید',
    replies: '{{ count }} پاسخ',
    hideReplies: 'پنهان کردن پاسخ ها',
    deletedComment: 'این نظر حذف شده است.',
    like: 'مانند',
    dislike: 'دوست نداشتن',
    unlike: 'بر خلاف',
    undislike: 'دوست نداشتن',
    sendNewComment: 'ارسال نظر جدید',
    deleteComment: 'حذف نظر',
  },
}
